import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { IconButton, Typography, Box } from "@mui/material";
import { ExpandMore, ExpandLess, Close } from "@mui/icons-material";
import Accordion from "./Accordion";

export default function SortableItem({ item, handleExpand, handleClose }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
        useSortable({ id: item?.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.6 : 1,
        zIndex: isDragging ? 1000 : "auto",
        // cursor: "grab",
    };

    return (
        <Box
            ref={setNodeRef}
            style={style}
            {...attributes}
            sx={{
                p: 2,
                mb: 2,
                display: item?.display ? "flex" : "none",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "column",
                transition: "background 0.3s",
                borderRadius: "10px",
                bgcolor: "white"
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                <Typography sx={{ flexGrow: 1 }}>{item?.label}</Typography>

                {/* Drag Handle */}
                {item?.label !== "Quick Links" && <IconButton {...listeners} sx={{ cursor: "grab"}}>
                    <img src={require("../assets/drag.png")} alt="Drag" />
                </IconButton>}

                <IconButton onClick={() => handleExpand(item.id)}>
                    {item?.expanded ? <ExpandLess /> : <ExpandMore />}
                </IconButton>

                {item?.label !== "Quick Links" && <IconButton onClick={() => handleClose(item?.id)}>
                    <Close />
                </IconButton>}
            </Box>

            {item?.expanded && (
                item?.data ?
                    <Accordion data={item?.data} />
                    : <Typography sx={{ mt: 1, width: "100%", textAlign: "center", p: 1, background: "#f9f9f9" }}>
                        Dummy expanded content for {item?.label}.
                    </Typography>
            )}
        </Box>
    );
}
